// Supplement the product view on the product homepage using the existing vendor tags.
// Product URLs and all cart/checkout events stay with the native Shopify integrations.
(() => {
  const node = document.getElementById('femure-home-product-view');
  if (!node || window.femureHomeProductView) return;
  window.femureHomeProductView = true;
  const data = JSON.parse(node.textContent);
  const sent = {
    shopify: false,
    google: !data.googleDestinations?.length,
    meta: !data.metaPixel,
    omnisend: !data.omnisendProduct,
  };
  let eventId;
  let timer;
  let attempts = 0;

  function flush() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const analytics = privacy.analyticsProcessingAllowed();
    const marketing = privacy.marketingAllowed();
    const native = window.ShopifyAnalytics?.lib;
    if (!sent.shopify && (analytics || marketing) && native?.trekkie && typeof native.track === 'function') {
      // Shopify returns the ID used by its own receiver and server-side integrations.
      eventId = native.track('Viewed Product', data.shopifyProduct);
      sent.shopify = true;
    }
    const nativePageView = (window.dataLayer || []).find(entry =>
      entry[0] === 'event' && entry[1] === 'page_view' && entry[2]?.ext_client_id)?.[2];
    if (!sent.google && eventId && (analytics || marketing) && nativePageView && typeof window.gtag === 'function') {
      const item = data.googleItem;
      window.gtag('event', 'view_item', {
        send_to: data.googleDestinations,
        event_id: eventId,
        ext_client_id: nativePageView.ext_client_id,
        user_data: nativePageView.user_data,
        currency: data.currency,
        value: item.price,
        ecomm_prodid: [item.id],
        ecomm_totalvalue: item.price,
        ecomm_pagetype: 'product',
        items: [item],
      });
      sent.google = true;
    }
    if (!sent.meta && eventId && analytics && marketing && privacy.saleOfDataAllowed() && typeof window.fbq === 'function') {
      window.fbq('trackSingle', data.metaPixel, 'ViewContent', data.metaContent, { eventID: eventId });
      sent.meta = true;
    }
    if (!sent.omnisend && analytics && marketing && privacy.saleOfDataAllowed() && window.Shopify.analytics?.publish) {
      const variantId = document.querySelector('.js-hero-offer.is-active')?.dataset.variantId;
      const variant = data.omnisendVariants.find(item => item.variantId === variantId);
      if (variant) {
        // The installed Omnisend app subscribes to this event on native product pages too.
        window.Shopify.analytics.publish('omnisend_viewed_product', {
          ...data.omnisendProduct, ...variant, url: window.location.href,
        });
        sent.omnisend = true;
      }
    }
    if (sent.shopify && sent.google && sent.meta && sent.omnisend) {
      clearInterval(timer);
      document.removeEventListener('visitorConsentCollected', restart);
      window.removeEventListener('load', flush, true);
    }
  }

  function restart() {
    clearInterval(timer);
    attempts = 0;
    flush();
    if (sent.shopify && sent.google && sent.meta && sent.omnisend) return;
    const privacy = window.Shopify.customerPrivacy;
    if (!privacy.analyticsProcessingAllowed() && !privacy.marketingAllowed()) return;
    timer = setInterval(() => {
      flush();
      if (++attempts >= 120) clearInterval(timer);
    }, 250);
  }

  document.addEventListener('visitorConsentCollected', restart);
  window.addEventListener('load', flush, true);
  if (window.Shopify?.customerPrivacy) restart();
  else window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (!error) restart();
  });
})();
